import React from 'react';

import Button from 'components/shared/Button';
import Divider from 'components/shared/Divider';
import View from 'components/shared/FileDropZone/View';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';

import styles from './index.module.css';

const Editor = ({ data, onDelete, onReplace, onSave }) => {
  const params = Array.isArray(data) ? data[0] : data;
  const { id, url, mimeType, height, width } = params;

  return (
    <div>
      <div className={styles.view}>
        <View url={url} type={mimeType} width={width} height={height} />
      </div>

      <Divider />

      <FormActions isRight marginTop>
        <Button children="Delete" type="default" onClick={onDelete} disabled={!id} />
        <Button children="Replace" type="default" onClick={onReplace} />
        <Button children="Save" onClick={onSave} disabled={!!id} />
      </FormActions>
    </div>
  );
};

export default Editor;
